import { coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import {
  MatListModule,
  type MatSelectionListChange,
} from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { type IFilterOption } from '@principle-theorem/shared';
import { ReplaySubject } from 'rxjs';
import { NgCommonModule } from '../ng-common.module';
import { TrackByFunctions } from '../track-by';

@Component({
  selector: 'pt-multi-filter-group',
  templateUrl: './multi-filter-group.component.html',
  styleUrls: ['./multi-filter-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgCommonModule,
    MatIconButton,
    MatIcon,
    MatMenuModule,
    MatListModule,
    MatTooltip,
  ],
})
export class MultiFilterGroupComponent {
  trackByFilter = TrackByFunctions.uniqueId<IFilterOption>();
  statusFilters$ = new ReplaySubject<IFilterOption[]>(1);
  activeStatuses$ = new ReplaySubject<string[]>(1);
  @Input() tooltip: string;
  @Input({ transform: coerceBooleanProperty }) compact: boolean = false;
  @Input() displayBadge: boolean = false;
  @Input() formatLabel: boolean = true;

  @Output()
  statusFilterChange = new EventEmitter<string[]>();

  @Input()
  set statusFilters(filters: IFilterOption[]) {
    if (filters) {
      this.statusFilters$.next(filters);
    }
  }

  @Input()
  set activeStatuses(statuses: string[]) {
    if (statuses) {
      this.activeStatuses$.next(statuses);
    }
  }

  updateSelected(event: MatSelectionListChange): void {
    this.statusFilterChange.next(
      event.source.selectedOptions.selected.map(
        (option) => option.value as string
      )
    );
  }
}
